export var Product;
(function (Product) {
    Product["STATUS"] = "Status";
    Product["NONE"] = "";
})(Product || (Product = {}));
